export const environment = {
  production: true,
  version: `v${__APP_VERSION__} (staging)`,
  graphql: {
    uri: 'https://api.staging.iqd-pro.com/graphql',
    wsUri: 'wss://api.staging.iqd-pro.com/graphql',
  },
  sentry: {
    dsn: 'https://0628eaf5015562c219b48ae89cf316b7@o4509351712194560.ingest.de.sentry.io/4509354974969936',
    environment: 'staging',
    enabled: true,
  },
  // Production is the only environment that reports to GTM. Development and
  // staging traffic would otherwise land in the live container and count as
  // real sessions in GA4.
  gtm: {
    id: 'GTM-PT7MKXQ',
    enabled: false,
  },
  turnstile: {
    siteKey: '0x4AAAAAADRq8aHuJAxp1ZKI',
  },
};
